module.exports = __webpack_public_path__ + "static/media/logout.fddd1273.svg";